import React, { useEffect, useState,useRef } from "react";
import { Box, Drawer, IconButton, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress, Checkbox, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";

// 🔹 Category Options
const categoryOptions = [
  { key: "medical", label: "Medical", value: "medical" },
  { key: "id", label: "ID", value: "id" },
  { key: "expense", label: "Expense", value: "expense" },
  { key: "other", label: "Other", value: "other" },
];

const FilterDrawer = ({ open, onClose, filters, setFilters, onApplyFilters }) => {
  const { t } = useTranslation();
  const [localFilters, setLocalFilters] = useState(filters);
  const [workers, setWorkers] = useState([]);
  const [loadingWorkers, setLoadingWorkers] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const company = useSelector((state) => state.auth.company);
  const companyId = company?.id;
  const startRef = useRef(null);
  const endRef = useRef(null);
  useEffect(() => {
    if (open) {
      // Convert workerIds string to array for multi-select
      const workerIdsArray = filters.workerIds 
        ? (filters.workerIds === "all" ? ["all"] : filters.workerIds.split(",").filter(Boolean))
        : [];
      setLocalFilters({ ...filters, workerIdsArray });
    }
  }, [open, filters]);

  // Fetch workers when drawer opens
  useEffect(() => {
    const fetchWorkers = async () => {
      if (!companyId || !open) return;
      
      setLoadingWorkers(true);
      try {
        const res = await fetch(`${BASE_URL}/public/workers?company_id=${companyId}&no_pagination=true&status=active`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });
        const data = await res.json();
        console.log("🔍 Workers data:", data);  
        if (!data.error && data.data?.records) {
          setWorkers(data.data.records);
        }
      } catch (err) {
        console.error("Error fetching workers:", err);
      } finally {
        setLoadingWorkers(false);
      }
    };

    if (open) fetchWorkers();
  }, [open, companyId, decryptedToken]);

  const apply = () => {
    // Convert workerIdsArray back to string format for API
    let workerIdsValue = "";
    if (localFilters.workerIdsArray && localFilters.workerIdsArray.length > 0) {
      if (localFilters.workerIdsArray.includes("all")) {
        workerIdsValue = "all";
      } else {
        workerIdsValue = localFilters.workerIdsArray.join(",");
      }
    }
    
    const filtersToApply = {
      ...localFilters,
      workerIds: workerIdsValue,
    };
    delete filtersToApply.workerIdsArray; // Remove temporary array property
    
    console.log("✅ Applying filters:", filtersToApply);
    onApplyFilters(filtersToApply);
    onClose();
  };

  const clear = () => {
    const cleared = { startDate: "", endDate: "", workerIds: "", workerIdsArray: [] };
    console.log("♻️ Clearing filters:", cleared);
    setLocalFilters(cleared);
    onApplyFilters({ ...cleared, workerIds: "" });
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 400, md: 550 },
          backgroundColor: "#E7EBEE",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#E7EBEE",
          zIndex: 10,
          px: 2,
          py: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
  {t("documentsTable.filter.heading")}
          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* Date From */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("documentsTable.filter.startDate")}</label>
            {/* <input
              type="date"
              value={localFilters.startDate || ""}
              onChange={(e) =>
                setLocalFilters((prev) => ({
                  ...prev,
                  startDate: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40 }}
            /> */}
              <input
               ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
    type="date"
    value={localFilters.startDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4); // restrict to 4 digits for year
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        setLocalFilters((prev) => ({
          ...prev,
          startDate: val,
        }));
      }
    }}
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
          </Box>

          {/* Worker Filter */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("documentsTable.filter.worker")}</label>
            <FormControl fullWidth sx={{ mt: 1 }}>
              <Select
                multiple
                value={localFilters.workerIdsArray || []}
                onChange={(e) => {
                  const selected = e.target.value;
                  // Handle "all" selection
                  if (selected.includes("all")) {
                    // If "all" is selected, only keep "all"
                    setLocalFilters((prev) => ({
                      ...prev,
                      workerIdsArray: ["all"],
                    }));
                  } else {
                    // If individual workers selected, remove "all" if present
                    setLocalFilters((prev) => ({
                      ...prev,
                      workerIdsArray: selected,
                    }));
                  }
                }}
                displayEmpty
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <em style={{ color: "#999", fontStyle: "italic" }}>{t("documentsTable.filter.selectWorker")}</em>;
                  }
                  if (selected.includes("all")) {
                    return t("documentsTable.filter.allEmployees");
                  }
                  if (selected.length === 1) {
                    const worker = workers.find(w => String(w.id) === selected[0]);
                    if (worker) {
                      const firstName = worker.first_name || '';
                      const middleName = worker.middle_name || '';
                      const lastName = worker.last_name || '';
                      const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ').trim() || 'Unknown';
                      return fullName;
                    }
                    return `${selected.length} ${t("documentsTable.filter.selected") || "selected"}`;
                  }
                  return `${selected.length} ${t("documentsTable.filter.employeesSelected") || "employees selected"}`;
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      marginTop: 8,
                    },
                  },
                }}
                sx={{
                  minHeight: 40,
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  backgroundColor: "#fff",
                  "& .MuiSelect-select": {
                    py: 1,
                    px: 1.5,
                    display: "flex",
                    alignItems: "center",
                    minHeight: "unset",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#091E4224",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#006EC2",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#006EC2",
                    borderWidth: "2px",
                  },
                }}
              >
                <MenuItem 
                  value="all" 
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 600,
                    color: "#006EC2",
                    py: 1,
                    px: 1.5,
                    borderBottom: "1px solid #E4E6EF",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <Checkbox
                    checked={localFilters.workerIdsArray?.includes("all") || false}
                    size="small"
                    sx={{ p: 0.5, mr: 1 }}
                  />
                  {t("documentsTable.filter.allEmployees")}
                </MenuItem>
                {loadingWorkers ? (
                  <MenuItem disabled sx={{ justifyContent: "center", py: 2 }}>
                    <CircularProgress size={20} />
                  </MenuItem>
                ) : (
                  workers.map((worker) => {
                    const firstName = worker.first_name || '';
                    const middleName = worker.middle_name || '';
                    const lastName = worker.last_name || '';
                    const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ').trim() || 'Unknown';
                    const email = worker.email || 'No email';
                    const workerIdStr = String(worker.id);
                    const isSelected = localFilters.workerIdsArray?.includes(workerIdStr) || false;
                    return (
                      <MenuItem 
                        key={worker.id} 
                        value={workerIdStr}
                        sx={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          py: 1,
                          px: 1.5,
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                        }}
                      >
                        <Checkbox
                          checked={isSelected}
                          size="small"
                          sx={{ p: 0.5, mr: 1 }}
                        />
                        <Box>
                          <Box sx={{ fontWeight: 500, color: "#172B4D" }}>{fullName}</Box>
                          <Box sx={{ fontSize: "12px", color: "#666", mt: 0.25 }}>{email}</Box>
                        </Box>
                      </MenuItem>
                    );
                  })
                )}
              </Select>
            </FormControl>
          </Box>

          {/* Date To */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("documentsTable.filter.endDate")}</label>
            {/* <input
              type="date"
              value={localFilters.endDate || ""}
              onChange={(e) =>
                setLocalFilters((prev) => ({
                  ...prev,
                  endDate: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40 }}
            /> */}
              <input
               ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
    type="date"
    value={localFilters.endDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        setLocalFilters((prev) => ({
          ...prev,
          endDate: val,
        }));
      }
    }}
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
          </Box>

          {/* Buttons */}
          <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", gap: 2 }}>
            <CustomButton
              onClick={apply}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                        {t("documentsTable.filter.apply")}

                </Box>
              }
              size="medium"
            />
            <Button
              variant="outlined"
              onClick={clear}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "fit-content",
              }}
            >
  {t("documentsTable.filter.clear")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
